import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

import UserLayout from "../layouts/UserLayout";
import Home from "../pages/User/Home";
import SignUp from "../pages/Auth/SignUp";
import SignIn from "../pages/Auth/SignIn";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import OTP from "../pages/Auth/OTP";
import ResetPassword from "../pages/Auth/ResetPassword";
import VendorOnboarding from "../pages/Auth/vendor/VendorOnboarding";
import AuthLayout from "../layouts/AuthLayout";
import VendorLayout from "../layouts/VendorLayout";
import Dashboard from "../pages/vendor/Dashboard";
import CreateExperience from "../pages/vendor/CreateExperience";
import BookingsPage from "../pages/vendor/BookingPage";
import Analytics from "../pages/vendor/Analytics";
import Payout from "../pages/vendor/Payout";
import ExploreYourExperiencesPage from "../pages/vendor/ExploreYourExperiences";
import SupportCenter from "../pages/Support/SupportCenter";
import Profile from "../pages/vendor/Profile";
import EditProfilePage from "../pages/vendor/EditProfilePage";
import BookingDetails from "../pages/vendor/BookingDetails";
import ExperienceDetails from "../pages/vendor/ExperienceDetails";
import UserHomePage from "../pages/User/UserHomePage";
import ExperienceDetailsPage from "../pages/User/ExperienceDetailsPage";
import ReviewBookingPage from "../pages/User/ReviewBookingPage";
import MyBookingsPage from "../pages/User/MyBookings";
import UserBookingDetailPage from "../pages/User/UserBookingDetail";
import UserProfilePage from "../pages/User/UserProfile";
import EditProfilePageUser from "../pages/User/EditProfile";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import AdminLayout from "../layouts/AdminLayout";
import VendorManagement from "../pages/Admin/VendorManagement";
import ExperienceManagement from "../pages/Admin/ExperienceManagement";
import BookingManagement from "../pages/Admin/BookingManagement";
import SupportTicket from "../pages/Admin/SupportTicket";
import PaymentMangement from "../pages/Admin/PaymentMangement";
import UserManagement from "../pages/Admin/UserManagement";
import ExploreCategoryPage from "../pages/User/ExploreCategoryPage";
import ExploreLocationPage from "../pages/User/ExploreLocationPage";
import ExperienceCardPage from "../pages/User/ExperienceCardPage";
import TicketDetailsPage from "../pages/Support/SupportDetails";
import VendorProfile from "../pages/Admin/VendorProfile";
import AdminExperienceDetails from "../pages/Admin/AdminExperienceDetailPage";
import AdminBookingDetailPage from "../pages/Admin/AdminBookingDetails";
import PaymentSuccessPage from "../pages/User/PaymentSuccessPage";
import AdminUserProfilePage from "../pages/Admin/UserProfileDetails";
import FirstFlightFund from "../pages/Public/FirstFlightFund";
import FAQs from "../pages/Public/FAQ";
import PrivacyPolicy from "../pages/Legal/PrivacyPolicy";
import TermsOfService from "../pages/Legal/TermsOfService";
import RefundCancellation from "../pages/Legal/RefundCancellation";
import Accessibility from "../pages/Legal/Accessibility";
import ExperienceDetailsGuest from "../pages/Guest/ExperienceDetails";
import VendorProfileGuest from "../pages/Guest/VendorProfileGuest";

const AppRoutes = () => {
  return (
    <Routes>
      {/* ============================================ */}
      {/* PUBLIC ROUTES - Accessible to everyone */}
      {/* ============================================ */}
      <Route path="/" element={<UserLayout />}>
        <Route index element={<Home />} />
        <Route path="/first-flight" element={<FirstFlightFund />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-cancellation" element={<RefundCancellation />} />
        <Route path="/accessibility" element={<Accessibility />} />
        <Route path="/experiences" element={<ExperienceCardPage />} />
        <Route
          path="/user/experience/:experienceId"
          element={<ExperienceDetailsPage />}
        />
        <Route
          path="/experiences/:experienceSlug"
          element={<ExperienceDetailsGuest />}
        />
        <Route path="/vendors/:vendorSlug" element={<VendorProfileGuest />} />
      </Route>

      {/* Auth Routes - Public */}
      <Route path="signup" element={<AuthLayout />}>
        <Route index element={<SignUp />} />
      </Route>

      <Route path="signin" element={<AuthLayout />}>
        <Route index element={<SignIn />} />
      </Route>

      <Route path="forgot-password" element={<AuthLayout />}>
        <Route index element={<ForgotPassword />} />
      </Route>

      <Route path="otp" element={<AuthLayout />}>
        <Route index element={<OTP />} />
      </Route>

      <Route path="reset-password" element={<AuthLayout />}>
        <Route index element={<ResetPassword />} />
      </Route>

      <Route path="vendor/onboarding" element={<AuthLayout />}>
        <Route index element={<VendorOnboarding />} />
      </Route>

      <Route path="/payment-success" element={<PaymentSuccessPage />} />

      {/* ============================================ */}
      {/* VENDOR ROUTES - Protected for Vendor role */}
      {/* ============================================ */}
      <Route
        path="vendor"
        element={
          <ProtectedRoute allowedRoles={["Vendor"]}>
            <VendorLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/vendor/dashboard" element={<Dashboard />} />
        <Route path="/vendor/bookings" element={<BookingsPage />} />
        <Route path="/vendor/experiences/new" element={<CreateExperience />} />
        <Route path="/vendor/analytics" element={<Analytics />} />
        <Route path="/vendor/payouts" element={<Payout />} />
        <Route
          path="/vendor/explore-experiences"
          element={<ExploreYourExperiencesPage />}
        />
        <Route path="/vendor/support" element={<SupportCenter />} />
        <Route path="/vendor/profile" element={<Profile />} />
        <Route path="/vendor/profile/edit" element={<EditProfilePage />} />
        <Route
          path="/vendor/booking-details/:bookingId"
          element={<BookingDetails />}
        />
        <Route
          path="/vendor/experience-details/:experienceId"
          element={<ExperienceDetails />}
        />
        <Route
          path="/vendor/experiences"
          element={<ExploreYourExperiencesPage />}
        />
        <Route
          path="/vendor/support-details/:ticketId"
          element={<TicketDetailsPage />}
        />
      </Route>

      {/* ============================================ */}
      {/* USER ROUTES - Protected for User role */}
      {/* ============================================ */}
      <Route
        path="user"
        element={
          <ProtectedRoute allowedRoles={["User"]}>
            <UserLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/user/home" element={<UserHomePage />} />
        <Route
          path="/user/experience/:experienceId"
          element={<ExperienceDetailsPage />}
        />
        <Route path="/user/review-booking" element={<ReviewBookingPage />} />
        <Route path="/user/my-bookings" element={<MyBookingsPage />} />
        <Route
          path="/user/booking-detail/:bookingId"
          element={<UserBookingDetailPage />}
        />
        <Route
          path="/user/category-detail/:categoryId"
          element={<ExploreCategoryPage />}
        />
        <Route
          path="/user/location-detail/:locationId"
          element={<ExploreLocationPage />}
        />
        <Route
          path="/user/experience-detail/"
          element={<ExperienceCardPage />}
        />
        <Route path="/user/profile" element={<UserProfilePage />} />
        <Route path="/user/profile/edit" element={<EditProfilePageUser />} />
        <Route path="/user/support" element={<SupportCenter />} />
        <Route
          path="/user/support-details/:ticketId"
          element={<TicketDetailsPage />}
        />
      </Route>

      {/* ============================================ */}
      {/* ADMIN ROUTES - Protected for Admin role */}
      {/* ============================================ */}
      <Route
        path="admin"
        element={
          <ProtectedRoute allowedRoles={["Admin"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/vendor-management" element={<VendorManagement />} />
        <Route path="/admin/vendors/:vendorId" element={<VendorProfile />} />
        <Route
          path="/admin/experience-management"
          element={<ExperienceManagement />}
        />
        <Route
          path="/admin/experiences/:experienceId"
          element={<AdminExperienceDetails />}
        />
        <Route
          path="/admin/booking-management"
          element={<BookingManagement />}
        />
        <Route
          path="/admin/booking-details/:bookingId"
          element={<AdminBookingDetailPage />}
        />
        <Route path="/admin/support-ticket" element={<SupportTicket />} />

        <Route
          path="/admin/payment-management"
          element={<PaymentMangement />}
        />
        <Route path="/admin/user-management" element={<UserManagement />} />
        <Route path="/admin/users/:userId" element={<AdminUserProfilePage />} />

        <Route
          path="/admin/support-details/:ticketId"
          element={<TicketDetailsPage />}
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
